import React from "react";

import { ExternalButton } from "@sharedComponents/buttons";
import Modal from "@stadium/ui/src/components/ModalNew";

import {
  ModalHeader,
  ModalContent,
  ModalDialog,
  ModalFooter,
} from "@stadium/ui/src/components/ModalNew/utils";
import { useWorkspaceContext } from "@contexts/workspace-context";

import { kitDashboard } from "@constants/external-routes";

import styles from "./main.module.scss";

const KitStatusModal = ({ kitState }) => {
  const { getDashboardUrlWithCurrentWorkspaceSlug } = useWorkspaceContext();

  return (
    <Modal newModal mobileBottomDrawer>
      <ModalDialog styles={styles}>
        <ModalContent className={styles.kitModalContent}>
          <ModalHeader>
            This kit is {kitState}. You cannot edit a {kitState} kit.
          </ModalHeader>
          <ModalFooter className={styles.modalFooter}>
            <ExternalButton
              href={getDashboardUrlWithCurrentWorkspaceSlug(kitDashboard)}
              styleType="primary"
            >
              Go to dashboard
            </ExternalButton>
          </ModalFooter>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );
};

export default KitStatusModal;
